// Generated TypeScript interfaces for settings

export enum TimesheetSettingsType {
  NORMAL = "NORMAL",
  START_STOP_TIME = "START_STOP_TIME"
}

